import { BetHistoryRequest } from './BetHistoryRequest'
import { BetHistoryResponse } from './BetHistoryResponse'
import { commonApiClient } from '../../../util/apiClient/commonApiClient'

export interface IBetHistoryApi {
  getBetHistory(request: BetHistoryRequest): Promise<BetHistoryResponse>
}

export const betHistoryApi: IBetHistoryApi = {
  async getBetHistory(request: BetHistoryRequest): Promise<BetHistoryResponse> {
    return (await commonApiClient.post<BetHistoryResponse>(`/player/betlist`, request)).data
  },
}

const mockApiPendingTime = 500
export const mockBetHistoryApi: IBetHistoryApi = {
  async getBetHistory(_: BetHistoryRequest): Promise<BetHistoryResponse> {
    await sleep(mockApiPendingTime)
    return Promise.resolve(mockBetHistoryApiData)
  },
}

const mockBetHistoryApiData: BetHistoryResponse = {
  betList: [
    {
      orderTime: '2025-03-27T06:28:46',
      refNo: 200000802144,
      payout: 0,
      stake: 1.2,
      statementDate: '2025-03-27T00:00:00',
      voucherId: '',
      voucherStake: 0,
    },
    {
      orderTime: '2025-03-27T06:28:43',
      refNo: 200000802143,
      payout: 0,
      stake: 1.2,
      statementDate: '2025-03-27T00:00:00',
      voucherId: '',
      voucherStake: 0,
    },
    {
      orderTime: '2025-03-27T06:21:37',
      refNo: 200000802142,
      payout: 0,
      stake: 1.2,
      statementDate: '2025-03-27T00:00:00',
      voucherId: '',
      voucherStake: 0,
    },
  ],
  currentPage: 0,
  pageCount: 1,
  pageSize: 200,
  betCount: 3,
  totalStake: 3.6,
  totalPayout: 0,
  totalWinLose: -3.6,
  returnCode: 0,
  message: '',
}

function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
